// extracted by mini-css-extract-plugin
module.exports = {"viewport":"PeekCarousel_viewport__Oi5Fr","scroller":"PeekCarousel_scroller__gjBs9","slide":"PeekCarousel_slide__axhkh","frame":"PeekCarousel_frame__aU19v"};